import React from 'react';
import {css} from 'emotion'
import pnc_logo from '../../../image/logo/pnc_logo.jpg';

const Logo = () =>{
  return(
    <div className={css`
                  background-image: url(${pnc_logo});
                  background-position:center;
                  background-repeat:no-repeat;
                  background-size:cover;
                  width:100px;height:40px`}/>
  )
}

export default Logo
